export default __webpack_public_path__ + "static/BanImg5-518c3f361e3456da5e87372d89c060c7.webp";